import { sub1, sub2, sub3, sub4, sub5,  } from './images';

export const dataInprogress = [{
    id: 1,
    name: 'اللغة الانكليزية',
    progress: 75,
    img: sub1,
    discretion: 'أحمد سعيد',
    date: '1/1/2022'
},
{
    id: 2,
    name: 'التربية الوطنية  ',
    progress: 25,
    img: sub2,
    discretion: 'أحمد سعيد',
    date: '1/1/2022'
},
{
    id: 3,
    name: 'الكيمياء',
    progress: 50,
    img: sub5,
    discretion: 'أحمد سعيد',
    date: '1/1/2022'
},
    {
        id: 4,
        name: 'التربية الوطنية  ',
        progress: 25,
        img: sub2,
        discretion: 'أحمد سعيد',
        date: '1/1/2022'
    },
{
    id: 5,
    name: 'اللغة الروسية',
    reating: '(24541534)',
    img: sub3,
    discretion: 'أحمد سعيد',
    date: '1/1/2022'
},
{
    id: 6,
    name: ' اللغة الانكليزية',
    reating: '(24541534)',
    img: sub1,
    discretion: 'أحمد سعيد',
    date: '1/1/2022'
},
{
    id: 7,
    name: ' التربية الوطنية',
    reating: '(24541534)',
    img: sub2,
    discretion: 'أحمد سعيد',
    date: '1/1/2022'
},
{
    id: 8,
    name: 'مادة علم الاحياء للصف التاسع الاساسي',
    reating: '(24541534)',
    img: sub3,
    discretion: 'أحمد سعيد',
    date: '1/1/2022'
},
{
    id: 9,
    name: 'مادة علم الاحياء للصف التاسع الاساسي',
    reating: '(24541534)',
    img: sub5,
    discretion: 'أحمد سعيد',
    date: '1/1/2022'
},
{
    id: 10,
    name: 'مادة علم الاحياء للصف التاسع الاساسي',
    reating: '(24541534)',
    img: sub3,
    discretion: 'أحمد سعيد',
    date: '1/1/2022'
},
{
    id: 11,
    name: 'مادة علم الاحياء للصف التاسع الاساسي',
    reating: '(24541534)',
    img: sub3,
    discretion: 'أحمد سعيد',
    date: '1/1/2022'
},
{
    id: 12,
    name: 'مادة علم الاحياء للصف التاسع الاساسي',
    reating: '(24541534)',
    img: sub1,
    discretion: 'أحمد سعيد',
    date: '1/1/2022'
},]